import { render, staticRenderFns } from "./ExchangeIndex.vue?vue&type=template&id=0644f130"
import script from "./ExchangeIndex.vue?vue&type=script&lang=js"
export * from "./ExchangeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports